export const GET_COUNTRIES_WATCHER = 'GET_COUNTRIES_WATCHER';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';
